<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="分类名称">
                  <el-input placeholder="请填写分类名称"  v-model="queryForm.categoryName"></el-input>
              </el-form-item>
              <el-form-item label="排序">
                  <el-input placeholder="请填写分类大小" v-model="queryForm.sort"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMallHotelBrandCategoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMallHotelBrandCategory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMallHotelBrandCategory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMallHotelBrandCategory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMallHotelBrandCategoryList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMallHotelBrandCategoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mallHotelBrandCategoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryName"
        label="分类名称"
        width="460"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="460"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMallHotelBrandCategory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMallHotelBrandCategory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMallHotelBrandCategory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mallHotelBrandCategoryStates[mallHotelBrandCategoryState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mallHotelBrandCategory"
          ref="mallHotelBrandCategoryForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="分类名称"
            prop="categoryName"
          >
            <el-input
              size="small"
              placeholder="请填写分类名称"
              v-model="mallHotelBrandCategory.categoryName"
              :disabled="mallHotelBrandCategoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              placeholder="请填写排序大小"
              v-model="mallHotelBrandCategory.sort"
              :disabled="mallHotelBrandCategoryState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mallHotelBrandCategoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMallHotelBrandCategoryList();
                    this.getMallHotelBrandCategoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMallHotelBrandCategoryList();
                    this.getMallHotelBrandCategoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     categoryName: '', //分类名称
                     sort: '', //排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mallHotelBrandCategoryState: 'add',
                mallHotelBrandCategoryStates: {
                    add: '新建品牌分类',
                    check: '查看品牌分类',
                    edit: '修改品牌分类'
                },

                multipleSelection: [],
                mallHotelBrandCategoryList: [],
                mallHotelBrandCategory: {
                    categoryName: '', //分类名称
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMallHotelBrandCategoryList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMallHotelBrandCategoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mallHotelBrandCategoryList = [];
            },
            resetDialog() {
                this.mallHotelBrandCategoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      categoryName: '', //分类名称
                      sort: '', //排序
                };
                this.getMallHotelBrandCategoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.mallHotelBrandCategory = {
                      categoryName: '', //分类名称
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.mallHotelBrandCategoryState == 'add') {
                    this.$refs.mallHotelBrandCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mall/hotelbrandcategory/add`,{ ...this.mallHotelBrandCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMallHotelBrandCategoryList();
                                    this.resetDialog();
                                }
                            });
                        }
                    });
                } else if (this.mallHotelBrandCategoryState == 'edit') {
                    this.$refs.mallHotelBrandCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.mallHotelBrandCategory.brandList

                            post(`/mall/hotelbrandcategory/edit`,{ ...this.mallHotelBrandCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMallHotelBrandCategoryList();
                                    this.resetDialog();
                                }
                            });
                        }
                    });
                }
            },
            addMallHotelBrandCategory() {
                this.showDialog = true;
                this.mallHotelBrandCategoryState = 'add';
            },
            checkMallHotelBrandCategory(mallHotelBrandCategoryId) {
                console.log(mallHotelBrandCategoryId);
                this.currentMallHotelBrandCategoryId = mallHotelBrandCategoryId;

                this.getMallHotelBrandCategoryById();
                this.showDialog = true;
                this.mallHotelBrandCategoryState = 'check';
            },
            editMallHotelBrandCategory(mallHotelBrandCategoryId) {
                console.log('mallHotelBrandCategory', mallHotelBrandCategoryId);
                if (mallHotelBrandCategoryId) {
                    this.currentMallHotelBrandCategoryId = mallHotelBrandCategoryId;
                    this.getMallHotelBrandCategoryById();
                } else {
                    this.mallHotelBrandCategory = { ...this.mallHotelBrandCategory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mallHotelBrandCategoryState = 'edit';
            },
            deleteMallHotelBrandCategory(mallHotelBrandCategoryId) {
                let ids = '';
                if (mallHotelBrandCategoryId) {
                    ids = mallHotelBrandCategoryId;
                } else {
                    ids = this.multipleSelection.map((mallHotelBrandCategory) => mallHotelBrandCategory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mall/hotelbrandcategory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMallHotelBrandCategoryList();
                                this.getMallHotelBrandCategoryList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMallHotelBrandCategoryList() {
                this.resetMallHotelBrandCategoryList();
                this.getMallHotelBrandCategoryList();
            },
            getMallHotelBrandCategoryList(query = {}) {
                this.loading = true;
                get(`/mall/hotelbrandcategory/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mallHotelBrandCategoryList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMallHotelBrandCategoryById() {
                get(`/mall/hotelbrandcategory/get`,{ id: this.currentMallHotelBrandCategoryId }).then((res) =>{
                    if(res.success){
                      this.mallHotelBrandCategory = { ...this.mallHotelBrandCategory, ...res.mallHotelBrandCategory };
                      console.log('this.mallHotelBrandCategory',this.mallHotelBrandCategory)
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMallHotelBrandCategoryList() {
                //this.btnLoading = true;
                exprotExcel(`/mall/hotelbrandcategory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mall/hotelbrandcategory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mall/hotelbrandcategory/importData`,formData);
              this.refreshMallHotelBrandCategoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMallHotelBrandCategoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMallHotelBrandCategoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>